export const lifiLogoUrl = 'https://lifinance.github.io/types/src/assets/icons/bridges/lifi.svg';
//# sourceMappingURL=lifi.js.map